import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsJsonConverterDate, UtilsString } from '@pit/core';
import { IDtoResourceType } from '../interfaces/dto.resource.type.interface';
import { IDtoMandator } from '../interfaces/dto.mandator.interface';
import { DtoMandator } from './dto.mandator';
import { IDtoResourceUser } from '../interfaces/dto.resource.user.interface';

// @dynamic
@JsonObject('DtoResourceUser')
export class DtoResourceUser extends ModelEntity implements IDtoResourceUser {

    constructor(initValues: Partial<IDtoResourceUser> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('resourceCode', String, true)
    public resourceCode?: string = null;

    @JsonProperty('resourceId', String, true)
    public resourceId?: string = null;

    @JsonProperty('userName', String, true)
    public userName?: string = null;

    @JsonProperty('userNumber', String, true)
    public userNumber?: string = null;

    @JsonProperty('timestampFrom', UtilsJsonConverterDate, true)
    public timestampFrom?: Date = null;

    @JsonProperty('timestampTill', UtilsJsonConverterDate, true)
    public timestampTill?: Date = null;

}
